import { useState } from "react";
import api from "../services/api";


export default function NieuweKlantModal({ onClose, onSaved }) {

  const [naam, setNaam] = useState("");
  const [adres, setAdres] = useState("");
  const [postcode, setPostcode] = useState("");
  const [plaats, setPlaats] = useState("");
  const [kvkNummer, setKvkNummer] = useState("");
  const [email, setEmail] = useState("");
  const [telefoon, setTelefoon] = useState("");
  const [contactNaam, setContactNaam] = useState("");
  const [createInitialLocation, setCreateInitialLocation] = useState(true);
  const [initialLocationName, setInitialLocationName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");


  const save = async () => {

    if (!naam.trim()) {
      setError("Naam is verplicht");
      return;
    }

    try {

      setLoading(true);

      const payload = {
        naam,
        adres,
        postcode,
        plaats,
        kvkNummer,
        email,
        telefoon,
        createInitialLocation: Boolean(createInitialLocation && String(adres || "").trim()),
        initialLocationName: String(initialLocationName || "").trim(),
      };

      if (String(contactNaam || "").trim()) {
        payload.contactPersons = [
          {
            name: String(contactNaam || "").trim(),
            email: String(email || "").trim(),
            phone: String(telefoon || "").trim(),
            active: true,
            isDefault: true,
          },
        ];
      }

      const res = await api.post("/clients", payload);

      onSaved?.(res?.data || null);

    } catch (err) {

      setError(
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Opslaan mislukt"
      );

    } finally {

      setLoading(false);
    }
  };


  return (
    <div className="
      fixed inset-0 bg-black/40
      flex items-center justify-center
      z-50
    ">

      {/* Klik buiten = sluiten */}
      <div
        className="absolute inset-0"
        onClick={onClose}
      />


      {/* Modal */}
      <div className="
        relative bg-white rounded-lg
        w-full max-w-md
        shadow-xl
        p-6
      ">

        <h2 className="text-lg font-semibold mb-4">
          Nieuwe klant
        </h2>


        {error && (
          <div className="
            bg-red-100 text-red-700
            p-2 rounded mb-3
            text-sm
          ">
            {error}
          </div>
        )}


        <div className="space-y-3">

          <input
            placeholder="Bedrijfsnaam *"
            value={naam}
            onChange={e => setNaam(e.target.value)}
            className="w-full border p-2 rounded"
          />

          <input
            placeholder="Adres"
            value={adres}
            onChange={e => setAdres(e.target.value)}
            className="w-full border p-2 rounded"
          />

          <div className="grid grid-cols-2 gap-2">
            <input
              placeholder="Postcode"
              value={postcode}
              onChange={e => setPostcode(e.target.value)}
              className="w-full border p-2 rounded"
            />
            <input
              placeholder="Plaats"
              value={plaats}
              onChange={e => setPlaats(e.target.value)}
              className="w-full border p-2 rounded"
            />
          </div>

          <label className="flex items-start gap-2 rounded border border-slate-200 bg-slate-50 p-3 text-sm text-slate-700">
            <input
              type="checkbox"
              checked={createInitialLocation}
              disabled={!String(adres || "").trim()}
              onChange={(event) => setCreateInitialLocation(event.target.checked)}
              className="mt-0.5"
            />
            <span>
              <span className="block font-medium">Eerste locatie aanmaken met dit adres</span>
              <span className="block text-xs text-slate-500">Direct beschikbaar in de Asset Builder. Vul eerst een adres in.</span>
            </span>
          </label>

          {createInitialLocation && String(adres || "").trim() ? (
            <input
              placeholder="Naam eerste locatie (optioneel)"
              value={initialLocationName}
              onChange={e => setInitialLocationName(e.target.value)}
              className="w-full border p-2 rounded"
            />
          ) : null}

          <input
            placeholder="KVK-nummer"
            value={kvkNummer}
            onChange={e => setKvkNummer(e.target.value)}
            className="w-full border p-2 rounded"
          />

          <input
            placeholder="Contactpersoon (optioneel)"
            value={contactNaam}
            onChange={e => setContactNaam(e.target.value)}
            className="w-full border p-2 rounded"
          />

          <input
            placeholder="E-mail"
            value={email}
            onChange={e => setEmail(e.target.value)}
            className="w-full border p-2 rounded"
          />

          <input
            placeholder="Telefoon"
            value={telefoon}
            onChange={e => setTelefoon(e.target.value)}
            className="w-full border p-2 rounded"
          />

        </div>


        {/* Acties */}
        <div className="flex justify-end gap-2 mt-5">

          <button
            onClick={onClose}
            className="px-3 py-1 border rounded"
          >
            Annuleren
          </button>

          <button
            disabled={loading}
            onClick={save}
            className="
              bg-blue-600 text-white
              px-4 py-1 rounded
              disabled:opacity-50
            "
          >
            {loading ? "Opslaan..." : "Opslaan"}
          </button>

        </div>

      </div>

    </div>
  );
}
